module.exports = __webpack_public_path__ + "static/img/earth_bg.7146fe85.png";